"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemNoResults = exports.MenuItemsContainer = exports.SearchContainer = exports.MenuContainer = exports.MenuItem = exports.MenuComponentWrapper = exports.menuLocationOptions = void 0;
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
function returnMenuLocationCss(location) {
    switch (location) {
        case 'top-right':
            return `
      position: absolute; top:0; left:100%; margin-left: 5px;
      `;
        case 'top-left':
            return `
      position: absolute; top:0; right:100%; margin-right: 5px;
      `;
        case 'above':
            return `
      position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%); margin-bottom: 5px;
      `;
        case 'on-top-of':
            return `
      position: absolute; top: 0%; left: 50%; transform: translateX(-50%);
      `;
        case 'middle-right':
            return `
      position: absolute; top:50%; left:100%; margin-left: 5px;
      `;
        case 'middle-left':
            return `
      position: absolute; top:50%; right:100%; margin-right: 5px;
      `;
        case 'bottom-right':
            return `
      position: absolute; left:100%; margin-left: 5px;
      `;
        case 'bottom-left':
            return `
      position: absolute; right:100%; margin-right: 5px;
      `;
        case 'below':
            return `
      position: absolute; left: 50%; transform: translateX(-50%); margin-top: 5px;
      `;
        case 'below-block':
            return `
      position: unset; margin-left: 50%; transform: translateX(-50%); margin-top: 5px;
      `;
        default:
            return `
      position: absolute; top:0; left:100%; margin-left: 5px;
      `;
    }
}
const MenuComponentWrapper = Theme_1.styled.div `
  position: relative;
  display: inline-block;
  height: min-content;
  line-height: 1;
  ${(props) => `width: ${props.width}`}
`;
exports.MenuComponentWrapper = MenuComponentWrapper;
exports.menuLocationOptions = [
    'top-right',
    'top-left',
    'above',
    'on-top-of',
    'middle-right',
    'middle-left',
    'bottom-right',
    'bottom-left',
    'below',
    'below-block',
];
const SearchContainer = Theme_1.styled.div `
  display: flex;
  justify-content: center;
  padding: 8px 8px 16px 8px;
`;
exports.SearchContainer = SearchContainer;
const MenuItemsContainer = Theme_1.styled.div `
  overflow-y: auto;
  max-height: 200px;
  min-width: 112px;
  overflow-x: hidden;
  scrollbar-color: ${(props) => props.theme.gray4} transparent;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color: ${(props) => props.theme.gray4};
    :hover {
      background-color: ${(props) => props.theme.gray3};
    }
  }
`;
exports.MenuItemsContainer = MenuItemsContainer;
const MenuContainer = Theme_1.styled.div `
  overflow: auto;
  background-color: ${(props) => props.theme.white};
  padding: 2px 0px;
  width: ${(props) => (props.width ? props.width : 'max-content')};
  max-height: 300px;
  min-width: 112px;
  height: max-content;
  border-radius: 4px;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
  z-index: 3;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  ${(props) => returnMenuLocationCss(props.menuLocation || 'top-right')}
`;
exports.MenuContainer = MenuContainer;
const MenuItemContainer = Theme_1.styled.li `
  background-color: ${(props) => props.theme.white};
  display: flex;
  height: 48px;
  justify-content: space-between;
  min-width: 112px;
  align-items: center;
  padding: 0px 16px;
  width: auto;
  :hover {
    background-color: ${(props) => props.theme.gray5};
    cursor: pointer;
  }
`;
const MenuItemNoResults = Theme_1.styled.li `
  background-color: ${(props) => props.theme.white};
  display: flex;
  height: 48px;
  justify-content: space-between;
  min-width: 112px;
  align-items: center;
  padding: 0px 16px;
  width: auto;
`;
exports.MenuItemNoResults = MenuItemNoResults;
const MenuItem = (props) => {
    const { className, onClick, width } = props;
    return (React.createElement(MenuItemContainer, { className: className || 'CloverMenuItem', onClick: () => onClick && onClick(), width: width }, props.children));
};
exports.MenuItem = MenuItem;
//# sourceMappingURL=BaseComponents.js.map